import React, { Fragment, useState } from "react";
import Carousel, { Modal, ModalGateway } from "react-images";
import { Container, Row } from "reactstrap";

import "./styles.scss";

const GridModalImages = ({ isLoading, images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const toggleLightbox = (selectedIndex) => {
    setSelectedIndex(selectedIndex);
    setIsLightboxOpen(!isLightboxOpen);
  };

  return (
    <Fragment>
      {!isLoading && images?.length ? (
        <Container>
          <Row>
            <div className="gallery">
              {images.map((image, j) => (
                <div
                  className="image"
                  onClick={() => toggleLightbox(j)}
                  key={j}
                >
                  <img
                    src={image}
                  />
                </div>
              ))}
            </div>
          </Row>
        </Container>
      ) : null}

      <ModalGateway>
        {isLightboxOpen && !isLoading ? (
          <Modal onClose={toggleLightbox}>
            <Carousel
              currentIndex={selectedIndex}
              styles={{
                view: (base) => ({
                  ...base,
                  height: "80vh",
                  display: "flex !important",
                  justifyContent: "center",
                  alignItems: "center",
                }),
                container: () => ({
                  maxHeight: "80vh",
                }),
                headerFullscreen: () => ({
                  display: "none",
                }),
              }}
              views={images.map((image) => ({ source: image }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </Fragment>
  );
};

export default GridModalImages;
